import { Collapse, Divider } from '@nextui-org/react';
import styled from 'styled-components';

import { ChevronIcon } from '../../assets';
import { ThemeProp } from '../../theme/Themes';

//const height = '4.5rem';

interface CollapseProps {
  backgroundColor?: string;
  maxHeight?: string;
  expanded?: boolean;
}

export const StyledCollapse = styled(Collapse).attrs((props) => ({
  css: {
    background: props.expanded ? props.theme.colors.secondary['12-light-blue'] : 'transparent',
    ...props.css,
  },
}))<CollapseProps>`
  border-radius: 0.5rem;
  padding: 0rem 0.5rem;
  width: 100%;
  ${(props) => props.maxHeight && `max-height: ${props.maxHeight};`}
  overflow-y: ${(props) => (props.scrollable ? 'scroll' : 'hidden')};

  &:hover {
    background: ${({ theme }: ThemeProp) => theme.colors.secondary['12-light-blue']};
  }

  [role='button'] {
    cursor: pointer;
    padding: 0;
    margin: 0;
  }

  .nextui-collapse-title-content {
    display: none;
  }

  .nextui-collapse-title-content-left {
    flex: 1;
    overflow: hidden;
  }

  .nextui-collapse-title-content-right {
    width: unset;
    flex: unset;
  }

  .nextui-collapse-view[aria-expanded='false'] {
    .nextui-collapse-title-container {
      .nextui-collapse-title-content-right {
        svg {
          transform: rotateZ(-90deg);
        }
      }
    }
  }

  .nextui-collapse-view[aria-expanded='true'] {
    .nextui-collapse-title-container {
      .nextui-collapse-title-content-right {
        svg {
          transform: rotateZ(0deg);
        }
      }
    }
  }
`;

export const StyledCollapseTitle = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.625rem 0 0.625rem 0;
  min-height: 3.5rem;
`;

export const ChevronContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 0.5rem;
  width: 1.5rem;
`;

export const StyledDivider = styled(Divider)`
  background-color: ${(props: ThemeProp) => props.theme.colors.greyscale.c050};
`;

export const StyledChevronIcon = styled(ChevronIcon)`
  height: 0.5rem;
  stroke: ${(props: ThemeProp) => props.theme.colors.white};
`;
